import useCreatePaymentMethod from 'modules/payment-methods/hooks/use-create-payment-method';
import {
  PaymentMethodProps,
  PaymentTypeEnum,
  translatedPaymentMethodProps,
} from 'modules/payment-methods/types';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreatePaymentMethod: React.FC = () => {
  const {getInput, getSwitch, getSelect} = useFormInputs<PaymentMethodProps>();

  return (
    <Creation<PaymentMethodProps>
      titleBar={{title: 'Cadastrar forma de pagamento'}}
      onSubmit={useCreatePaymentMethod}
      {...{defaultValues: {active: true}}}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'type',
          data: [
            {label: 'Online', value: PaymentTypeEnum.ONLINE},
            {label: 'Na entrega', value: PaymentTypeEnum.IN_PERSON},
          ],
        }),
      ]}
      translationKey={translatedPaymentMethodProps}
    />
  );
};

export default CreatePaymentMethod;
